import { Modal } from "react-bootstrap";
import styled from "styled-components";

export const DateRangePickerModal = styled(Modal)`
  .modal-dialog {
    .modal-content {
      padding: 0 !important;
      max-width: max-content !important;
      border-radius: 16px;
      border: 1px solid rgba(31, 31, 31, 0.08);
      background: #fff;
      gap: 0;

      .modal-body {
        .react-datepicker {
          display: flex;
          border: none;
          border-radius: 16px 16px 0 0;
          border: 1px solid rgba(31, 31, 31, 0.08);
          background-color: #fff;

          .react-datepicker__month-container {
            width: 100%;
            border-right: 1px solid rgba(31, 31, 31, 0.08);
            padding: 20px 22px;

            .custom-datepicker-header {
              position: relative;
              color: #1f1f1f;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-bottom: 12px;

              .nav-arrow {
                padding: 2px;
                cursor: pointer;
                display: flex;

                &:hover {
                  border-radius: 40px;
                  background: rgba(31, 31, 31, 0.04);
                }

                &.prev {
                  /* transform: rotate(90deg); */
                  position: absolute;
                  top: 0;
                }

                &.next {
                  /* transform: rotate(-90deg); */
                  position: absolute;
                  top: 0;
                  right: 0;
                }
              }
            }
            .react-datepicker__day-names {
              .react-datepicker__day-name {
                color: #1f1f1f;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                width: 40px;
                margin: 0;
                padding: 10px;
              }
            }

            .react-datepicker__header {
              border: none;
              background-color: transparent;
            }

            .react-datepicker__month {
              margin: 0;
              text-align: center;
              display: flex;
              flex-direction: column;
              gap: 4px;
            }

            .react-datepicker__day {
              margin: 0;
              color: #1f1f1f;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              border-radius: 0;
              padding: 10px;
              width: 40px;

              &:hover {
                border-radius: 40px;
                background-color: rgba(31, 31, 31, 0.04);
              }
            }

            .react-datepicker__day--today {
              color: #1f1f1f !important;
              font-size: 14px;
              font-weight: 700;
              line-height: 20px;
              background-color: transparent !important;
            }

            .react-datepicker__day--selected {
              background-color: #1f1f1f !important;
              color: #fff !important;
              border-radius: 40px !important;

              &:hover {
                color: #fff;
                background-color: #1f1f1f;
              }
            }

            .react-datepicker__day--selecting-range-start {
              background-color: #1f1f1f !important;
              color: #fff !important;
              border-radius: 40px !important;

              &:hover {
                color: #fff;
                background-color: #1f1f1f;
              }
            }

            .react-datepicker__day--in-range {
              background-color: rgba(31, 31, 31, 0.08) !important;
              color: #1f1f1f !important;
              border-radius: 0 !important;
              position: relative;
            }

            .react-datepicker__day--in-selecting-range {
              background-color: rgba(31, 31, 31, 0.08) !important;
              color: #1f1f1f !important;
              border-radius: 0 !important;
              position: relative;
            }

            .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start {
              background-color: #1f1f1f !important;
              border-radius: 40px !important;
              color: #fff !important;
            }

            /* Start and End black circle (on top of in-range background) */
            .react-datepicker__day--range-start,
            .react-datepicker__day--range-end {
              position: relative;
              color: #fff !important;
              z-index: 1; /* make sure it stays above */
            }

            .react-datepicker__day--range-start::before,
            .react-datepicker__day--range-end::before {
              content: "";
              position: absolute;
              top: 2px;
              left: 2px;
              right: 2px;
              bottom: 2px;
              background-color: #1f1f1f;
              border-radius: 40px;
              z-index: -1;
            }

            /* Just in case it's both in-range and selected (avoid override by in-range) */
            .react-datepicker__day--range-start.react-datepicker__day--in-range,
            .react-datepicker__day--range-end.react-datepicker__day--in-range {
              color: #fff !important;
            }

            .react-datepicker__day--range-start.react-datepicker__day--in-range {
              border-radius: 40px 0 0 40px !important;
            }

            .react-datepicker__day--range-end.react-datepicker__day--in-range {
              border-radius: 0 40px 40px 0 !important;
            }

            .react-datepicker__day--disabled {
              color: rgba(31, 31, 31, 0.4) !important;
              cursor: not-allowed !important;
              pointer-events: none;
              background-color: transparent !important;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
            }

            .react-datepicker__day--outside-month {
              opacity: 0;
            }

            .react-datepicker__day--keyboard-selected {
              background-color: transparent;
            }

            .react-datepicker__day--range-start.react-datepicker__day--range-end {
              background-color: #1f1f1f !important;
              color: #fff !important;
              border-radius: 40px !important;
            }
          }

          .react-datepicker__navigation {
            display: none;
          }
        }

        .calendar-single-month {
          border-radius: 16px;
          border: none;

          .nav-arrow {
            transform: none !important;
          }

          .react-datepicker__month-container {
            padding: 0;

            /* ✅ DAY GRID (TABLE) */
            div[role="table"] {
              padding: 16px;
            }

            .react-datepicker__header {
              padding: 16px;
              border-bottom: 1px solid var(--Neutral-4);
            }

            .custom-datepicker-header {
              margin: 0;
              padding: 0;

              .month-label {
                color: var(--Neutral-100);
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                letter-spacing: -0.16px;
              }
            }
          }
        }
      }

      .modal-footer {
        display: flex;
        padding: 16px;
        justify-content: space-between;
        align-items: center;
        gap: 12px;

        &.two-month-footer {
          width: 100%;

          .footer-button-wrapper {
            width: 100%;

            button {
              width: 100%;
            }

            &.custom-date-footer {
              width: auto;

              button {
                padding: 8px 32px;
              }
            }
          }
        }

        .show-date-range-wrapper {
          display: flex;
          align-items: center;
          gap: 12px;

          .form-control {
            height: 40px;
            border-radius: 8px;
            border: 1px solid rgba(31, 31, 31, 0.08);
            outline: none;
            padding: 8px 12px;
            overflow: hidden;
            color: #1f1f1f;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            width: 137px;

            &.has-value {
              border: 1px solid #1f1f1f;
            }

            &::placeholder {
              opacity: 0.4;
            }

            &.active-start {
              border: 1px solid rgba(31, 31, 31, 0.08);
            }
          }

          .divider {
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
          }
        }

        .footer-button-wrapper {
          display: flex;
          gap: 12px;
        }
      }
    }
  }
`;

export const DateInputStyles = styled.div`
  .field.date-field {
    position: relative;
  }

  .date-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 9999;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    margin-top: 4px;
  }

  .react-datepicker {
    display: flex;
    border: none;
    border-radius: 16px;
    border: 1px solid rgba(31, 31, 31, 0.08);
    background-color: #fff;

    .react-datepicker__month-container {
      width: 100%;
      border-right: 1px solid rgba(31, 31, 31, 0.08);
      padding: 20px 22px;
      border-radius: 16px;

      .custom-datepicker-header {
        position: relative;
        color: #1f1f1f;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 12px;

        .nav-arrow {
          padding: 2px;
          cursor: pointer;
          display: flex;

          &:hover {
            border-radius: 40px;
            background: rgba(31, 31, 31, 0.04);
          }

          &.prev {
            transform: rotate(90deg);
            position: absolute;
            top: 0;
          }

          &.next {
            transform: rotate(-90deg);
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
      .react-datepicker__day-names {
        .react-datepicker__day-name {
          color: #1f1f1f;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          width: 40px;
          margin: 0;
          padding: 10px;
        }
      }

      .react-datepicker__header {
        border: none;
        background-color: transparent;
      }

      .react-datepicker__month {
        margin: 0;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .react-datepicker__day {
        margin: 0;
        color: #1f1f1f;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        border-radius: 0;
        padding: 10px;
        width: 40px;

        &:hover {
          border-radius: 40px;
          background-color: rgba(31, 31, 31, 0.04);
        }
      }

      .react-datepicker__day--today {
        color: #1f1f1f !important;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        background-color: transparent !important;
      }

      .react-datepicker__day--selected {
        background-color: #1f1f1f !important;
        color: #fff !important;
        border-radius: 40px !important;

        &:hover {
          color: #fff;
          background-color: #1f1f1f;
        }
      }

      .react-datepicker__day--selecting-range-start {
        background-color: #1f1f1f !important;
        color: #fff !important;
        border-radius: 40px !important;

        &:hover {
          color: #fff;
          background-color: #1f1f1f;
        }
      }

      .react-datepicker__day--in-range {
        background-color: rgba(31, 31, 31, 0.08) !important;
        color: #1f1f1f !important;
        border-radius: 0 !important;
        position: relative;
      }

      .react-datepicker__day--in-selecting-range {
        background-color: rgba(31, 31, 31, 0.08) !important;
        color: #1f1f1f !important;
        border-radius: 0 !important;
        position: relative;
      }

      .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start {
        background-color: #1f1f1f !important;
        border-radius: 40px !important;
        color: #fff !important;
      }

      /* Start and End black circle (on top of in-range background) */
      .react-datepicker__day--range-start,
      .react-datepicker__day--range-end {
        position: relative;
        color: #fff !important;
        z-index: 1; /* make sure it stays above */
      }

      .react-datepicker__day--range-start::before,
      .react-datepicker__day--range-end::before {
        content: "";
        position: absolute;
        top: 2px;
        left: 2px;
        right: 2px;
        bottom: 2px;
        background-color: #1f1f1f;
        border-radius: 40px;
        z-index: -1;
      }

      /* Just in case it's both in-range and selected (avoid override by in-range) */
      .react-datepicker__day--range-start.react-datepicker__day--in-range,
      .react-datepicker__day--range-end.react-datepicker__day--in-range {
        color: #fff !important;
      }

      .react-datepicker__day--range-start.react-datepicker__day--in-range {
        border-radius: 40px 0 0 40px !important;
      }

      .react-datepicker__day--range-end.react-datepicker__day--in-range {
        border-radius: 0 40px 40px 0 !important;
      }

      .react-datepicker__day--disabled {
        color: rgba(31, 31, 31, 0.4) !important;
        cursor: not-allowed !important;
        pointer-events: none;
        background-color: transparent !important;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }

      .react-datepicker__day--outside-month {
        opacity: 0;
      }

      .react-datepicker__day--keyboard-selected {
        background-color: transparent;
      }

      .react-datepicker__day--range-start.react-datepicker__day--range-end {
        background-color: #1f1f1f !important;
        color: #fff !important;
        border-radius: 40px !important;
      }
    }

    .react-datepicker__navigation {
      display: none;
    }
  }

  .calendar-single-month {
    border-radius: 16px;
    border: none;

    .nav-arrow {
      transform: none !important;
    }

    .react-datepicker__month-container {
      padding: 0;

      /* ✅ DAY GRID (TABLE) */
      div[role="table"] {
        padding: 16px;
      }

      .react-datepicker__header {
        padding: 16px;
        border-bottom: 1px solid var(--Neutral-4);
      }

      .custom-datepicker-header {
        margin: 0;
        padding: 0;

        .month-label {
          color: var(--Neutral-100);
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: -0.16px;
        }
      }
    }
  }
`;
